// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#lottie[data-v-bfc0dfa0]{background-color:#fff;width:150px;height:150px;display:block;overflow:hidden;transform:translateZ(0);text-align:center;opacity:1}", ""]);
// Exports
module.exports = exports;
